import $ from 'jquery';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '../targeting-settings-context';
import { getLocationDisplayName } from '../helpers';
import locationColumn from './template/location-column.pug';

export default class ColumnLocation extends CampaignuiBaseColumn {
  constructor({ i18n, isExcludeLocation = '' }) {
    const localizedTitle = i18n.getString('TargetingSettings_Grid_Locations_Column_Location');

    super({
      name: 'Location',
      title: 'TargetingSettings_Grid_Locations_Column_Location',
      property: 'Criterion',
      sortable: 'Criterion/Name',
      type: 'string',
      helpId: 'pop_BA_Settings_Location_Location',
      i18n,
      bodyClasses: ['grid-column-Location'],
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
    this.gridType = isExcludeLocation ? 'excluded-locations' : 'locations';
    this.deprecatedTextMapping = {
      PendingDeprecation: {
        warning: i18n.getString('Location_Target_Pending_Deprecation'),
        title: i18n.getString('Location_Target_Location_Pending_Deprecation_Title'),
        text: i18n.getString('Location_Target_Location_Pending_Deprecation_Text'),
      },
      Deprecated: {
        warning: i18n.getString('Location_Target_Deprecated'),
        title: i18n.getString('Location_Target_Location_Deprecated_Title'),
        text: i18n.getString('Location_Target_Location_Deprecated_Text'),
      },
    };
  }

  get property() {
    return {
      get: (item) => {
        const { LevelOfDetails, Criterion = {}, VirtualId } = item;
        const inherited = LevelOfDetails === 'Campaign';
        const name = getLocationDisplayName(item);

        const { locationTargetStatusPopup, isDeprecatedLocation, locationConstants }
          = TargetingSettingsContext;
        const showDeprecatedWarning = isDeprecatedLocation(Criterion);
        let deprecatedTexts = {};

        // TODO: remove the mock data
        // if (LevelOfDetails) {
        //   Criterion.LocationStatus = 'Deprecated';
        // }

        if (showDeprecatedWarning) {
          deprecatedTexts = locationConstants.deprecatedTextMapping[Criterion.LocationStatus];
          const containerSelector = `#${VirtualId} .location-cell-status`;
          const locationView = $(`.${this.gridType}-view`);

          locationView.on('mouseover', containerSelector, (event) => {
            locationTargetStatusPopup(event, deprecatedTexts, containerSelector);
          });

          locationView.on('click', containerSelector, (event) => {
            locationTargetStatusPopup(event, deprecatedTexts, containerSelector);
          });
        }

        return {
          name,
          inherited,
          showDeprecatedWarning,
          deprecatedText: deprecatedTexts && deprecatedTexts.warning,
        };
      },
      key: this.config.property,
    };
  }

  template({ value }) {
    const options = {
      name: value.name,
      inherited: value.inherited,
      showDeprecatedWarning: value.showDeprecatedWarning,
      deprecatedText: value.deprecatedText,
    };

    return locationColumn(options);
  }
}
